import ArticleCard from "./ArticleCard";
import { Carousel } from "react-responsive-carousel";
import ReadMoreButton from "./ReadMoreButton";
import { useNavigate } from "react-router-dom";

export default function ArticleList({ articles, onArticleClick }) {
  const navigate = useNavigate();

  return (
    <>
      {/* Carousel per mobile, visibile solo su mobile tramite CSS */}
      <div className="mobile-article-carousel">
        <Carousel
          autoPlay
          infiniteLoop
          interval={3000}
          showThumbs={false}
          showStatus={false}
          dynamicHeight
          stopOnHover
          className="article-slider"
          navButtonsProps={{
            style: {
              backgroundColor: "transparent",
              color: "black",
            },
          }}
        >
          {articles.length > 0 &&
            articles.slice(0, 3).map((article, key) => (
              <div className="article-paper" key={article.id || key}>
                <ArticleCard article={article} onClick={onArticleClick} />
              </div>
            ))}
        </Carousel>
      </div>

      {/* Lista classica per desktop/tablet, visibile solo su desktop tramite CSS */}
      <div className="last-article-container">
        {articles &&
          articles
            .slice(0, 3)
            .map((article, key) => (
              <ArticleCard
                key={article.id || key}
                article={article}
                onClick={onArticleClick}
              />
            ))}
      </div>

      {/* Bottone Scopri di più */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "2rem 0",
          width: "100%",
        }}
      >
        <ReadMoreButton
          onClick={() => navigate("/blog")}
          text="Scopri di più"
        />
      </div>
    </>
  );
}
